import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getMeta } from '../utils';
import { absoluteUrl } from '../utils/url';
import { Helmet } from 'react-helmet';


class MetaData extends Component {
  render () {
    const { metaData, project, routing: { location: { pathname } } } = this.props;
    const { site, publisher } = metaData;
    const { title, description, image } = getMeta(metaData, 'page');
    // URL without query params
    const canonicalUrl = absoluteUrl(pathname);
    return (
      <Helmet titleTemplate={`%s | ${site.title}`} defaultTitle={site.title}>
        <html prefix="og: http://ogp.me/ns#" />
        <title>{title}</title>
        <meta name="description" content={description} />
        {publisher.name ? <meta name="author" content={publisher.name} /> : null}

        {/* Mobile device icons and colors */}
        {[57, 60, 72, 76, 114, 120, 144, 152].map(size => (
          <link key={size} rel="apple-touch-icon" sizes={`${size}x${size}`} href={`/icons/apple-touch-icon-${size}x${size}.png`} />
        ))}

        {[16, 32, 96].map(size => (
          <link key={size} rel="icon" type="image/png" sizes={`${size}x${size}`} href={`/icons/favicon-${size}x${size}.png`} />
        ))}

        <meta name="theme-color" content="#000000" />
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="/icons/mstile-144x144.png" />

        {/* Twitter-specific */}
        <meta name="twitter:card" content={image ? 'summary_large_image' : 'summary'} />
        {publisher.twitter ? <meta name="twitter:site" content={`@${publisher.twitter}`} /> : null}

        {/* Open Graph - parsed by both Twitter and Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        {image ? <meta property="og:image" content={image} /> : null}

        {/* Adobe Typekit */}
        {project.templateOptions.typekitId ? <link rel="stylesheet" href={`https://use.typekit.net/${project.templateOptions.typekitId}.css`} /> : null}
      </Helmet>
    );
  }
}

MetaData.propTypes = {
  metaData: PropTypes.object,
};

const mapStateToProps = ({ project, metaData, routing }) => ({ project, metaData, routing });

export default connect(mapStateToProps)(MetaData);



// WEBPACK FOOTER //
// ./src/components/MetaData.js